export const VALID_THEMES = ['dark', 'light'];
export const DEFAULT_THEME = VALID_THEMES[0];
